
import React from 'react';
import moment from 'moment';

import DatePicker from 'react-datepicker';

import API from 'service/api';
import Util, { Data, ActionType } from 'service/util';

import Form from 'component/Form';
import ServiceWeekdayPicker from 'component/service/ServiceWeekdayPicker';
import PopMessage from 'component/pop-msg/PopMessage';
import LocationSelect from 'component/dropdown/LocationSelect';
import ModalScreen from 'component/ModalScreen';

class AddServiceModal extends React.Component
{
  constructor(props)
  {
    super(props);
    // find top service
    let asv = props.vehicle.activeService || props.vehicle.services[0];

    this.state = {
      min_date: new Date(props.min_dtm),
      error: '',
      service: {
        company: 'TK',
        cd_license: props.vehicle.cd_license,
        owner_id: props.vehicle.owner_id,
        srv_plan: 'A',
        vh_type: props.vehicle.vh_type,
        srv_dis: Data.location[0].srv_dis,
        srv_loc: Data.location[0].srv_loc,
        srv_floor: '', srv_psn: '',
        weekday1: 0, weekday2: 0, weekday3: 0,
        waxing: true, rotation: '',
        fee: 0, extra_fee: 0,
        worker: Data.defaultWorkerId,
        remarks: '',
        ...asv,
        start_dtm: Util.getToday(),
        end_dtm: null,
      },
    };

    if (0 == this.state.service.fee) this.autoSetFee();

    this.setService  = this.setService.bind(this);
    this.autoSetFee  = this.autoSetFee.bind(this);
    this.setLocation = this.setLocation.bind(this);
    this.setCompany  = this.setCompany.bind(this);
    this.setPlan     = this.setPlan.bind(this);
    this.setWeekdays = this.setWeekdays.bind(this);
    this.submitModal = this.submitModal.bind(this);

  }

  setService(key, value)
  {
    this.state.service[key] = value;
    this.forceUpdate();
  }
  autoSetFee()
  {
    let { company, srv_dis, srv_loc, srv_plan } = this.state.service;
    let vh_type = this.props.vehicle.vh_type;
    this.state.service.fee = Data.price[`${company}/${srv_dis}${srv_loc}:${srv_plan}${vh_type}`]||0;
  }
  setLocation(dis, loc)
  {
    let service = this.state.service;
    service.srv_dis = dis;
    service.srv_loc = loc;
    this.autoSetFee();
    this.setState({service});
  }
  setCompany(com)
  {
    let service = this.state.service;
    service.company = com;
    this.autoSetFee();
    this.setState({service});
  }
  setPlan(plan)
  {
    let s = this.state.service;
    s.srv_plan = plan;
    switch (plan) {
      case 'A':
        s.weekday1 = 0;
        s.weekday2 = 0;
        s.weekday3 = 0;
        s.waxing   = true;
        break;
      case 'B':
        s.waxing   = true;
        break;
      case 'C':
        s.weekday2 = 0;
        s.weekday3 = 0;
        s.waxing   = false;
        break;
    }
    this.autoSetFee();
    this.forceUpdate();
  }
  setWeekdays(d1, d2, d3)
  {
    this.state.service.weekday1 = d1;
    this.state.service.weekday2 = d2;
    this.state.service.weekday3 = d3;
    this.forceUpdate();
  }

  get minEndDate()
  {
    let refDate = new Date(moment(this.state.service.start_dtm).valueOf());
    refDate.setHours(24,0,0,0);
    return refDate;
  }

  submitModal(e)
  {
    e.preventDefault();
    e.stopPropagation();

    let service = {...this.state.service, action: ActionType.Start};
    service.start_dtm = Util.ShortDate(service.start_dtm);
    service.end_dtm   = Util.ShortDate(service.end_dtm)||null; // proof

    API.changeServiceRecord(service).then(resp =>
    {
      if (resp.success) {
        // copy
        this.props.onCreatedService(resp.msg);
        PopMessage.show('已成功新增記錄。', '成功', 'success');
        this.props.closeModal();
      } else {
        PopMessage.show(resp.msg, '失敗', 'danger');
      }
    });

    return false;
  }

  render()
  {
    const s = this.state.service;
    const v = this.props.vehicle;
    return (
      <ModalScreen className="sem sem-add" show={true}
        title={`新增車輛服務 - ${v.cd_license}`}
        onClose={this.props.closeModal}>
        <Form className="sem-form" onSubmit={this.submitModal}>
          <p className="message green">
            為車輛新增月費服務記錄。
          </p>

          <label className="field">
            <strong>服務開始日</strong>
            <DatePicker selected={s.start_dtm} onChange={d=>this.setService('start_dtm', d)}
                        dateFormat="yyyy-MM-dd" minDate={this.state.min_date} />
          </label>
          <label className="field">
            <strong>服務結束日</strong>
            <DatePicker selected={s.end_dtm} onChange={d=>this.setService('end_dtm', d)}
                        dateFormat="yyyy-MM-dd" minDate={s.start_dtm} />
          </label>

          <div className="split-3">
            <label className="field">
              <strong>公司</strong>
              <select value={s.company} onChange={e=>this.setCompany(e.target.value)}>
                { Data.company.map(com =>
                  <option key={com.cd} value={com.cd}>{com.cd} - {com.name}</option>
                )}
              </select>
            </label>
            <label className="field">
              <strong>計劃</strong>
              <select value={s.srv_plan} onChange={e=>this.setPlan(e.target.value)}>
                { Data.plan.map(p =>
                  <option key={`plan-${p}`} value={p}>{ p }</option>
                )}
              </select>
            </label>
            <label className="field">
              <strong>服務日</strong>
              <ServiceWeekdayPicker plan={s.srv_plan}
                d1={s.weekday1} d2={s.weekday2} d3={s.weekday3}
                onChange={this.setWeekdays} />
            </label>
          </div>

          <div className="split-3">
            <LocationSelect labelClass="field"
              district={s.srv_dis}
              location={s.srv_loc}
              onUpdate={this.setLocation}
            />
          </div>

          <label className="field">
            <strong>打蠟</strong>
            <input type="checkbox" checked={s.waxing}
                  onChange={e=>this.setService('waxing', e.target.checked)} />
          </label>
          <div className="split-2">
            <label className="field">
              <strong>樓層</strong>
              <input type="text" placeholder="車輛停泊樓層" value={s.srv_floor}
                      onChange={e=>this.setService('srv_floor', e.target.value)} />
            </label>
            <label className="field">
              <strong>車位</strong>
              <input type="text" placeholder="車位號碼" value={s.srv_psn}
                      onChange={e=>this.setService('srv_psn', e.target.value)} />
            </label>
          </div>
          <div className="split-3">
            <label className="field">
              <strong>月費</strong>
              <input type="number" placeholder="價錢" value={s.fee} required
                      onChange={e=>this.setService('fee', parseFloat(e.target.value) )} />
            </label>
            <label className="field">
              <strong>附加項目</strong>
              <input type="text" placeholder="如輪抹車" value={s.rotation}
                     onChange={e=>this.setService('rotation', e.target.value )} />
            </label>
            <label className="field">
              <strong>附加費</strong>
              <input type="number" placeholder="每月固定收費" value={s.extra_fee} required
                     onChange={e=>this.setService('extra_fee', parseFloat(e.target.value) )} />
            </label>
          </div>
          <label className="field">
            <strong>負責工人</strong>
            <select value={s.worker} required
                    onChange={e=>this.setService('worker', parseInt(e.target.value, 10) )}>
              <option value={Data.defaultWorkerId}>公司預設 (ID={Data.defaultWorkerId})</option>
              { Data.wkrloc[`${s.srv_dis}${s.srv_loc}`]?.map(w =>
                <option key={`wkr-${w.uid}`} value={w.uid}>{w.cd} - {w.name}</option>
              )}
            </select>
          </label>

          <div className="error-msg">
            { this.state.error }
          </div>
          <div className="action-panel">
            <button className="btn grey" type="button"
                    onClick={e=>this.props.closeModal()}>關閉</button>
            <button id="btn-submit" className="btn blue" >確定</button>
          </div>
        </Form>
      </ModalScreen>
    );
  }

}


export default AddServiceModal;